<template>
  <v-container>
    <v-sheet outlined>
      <v-data-table
        :headers="headers"
        :items="eventItems"
        tableClasses="item-table border"
        responsive
        hide-default-footer
        disable-pagination
        fixed-header
        ref="baseTable"
      >
        <template v-slot:[`item.status`]="{ item }">
          {{ eventTypeDisplayName(item.status) }}
        </template>
        <template v-slot:[`item.createdTimeUtc`]="{ item }">
          {{ item.createdTimeUtc | moment }}
        </template>
        <template v-slot:[`item.comments`]="{ item }">
          <div
            @click="showAdminComments(item)"
            v-if="item.comments && item.comments.length"
          >
            {{ createComment(item.comments) }}
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn color="primary" @click="showMerchantHistory(item)" icon>
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <v-btn color="error" @click="deleteMerchantHistory(item)" icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-sheet>
    <v-dialog v-model="openDetailDialog" max-width="800">
      <v-card v-if="selectedMerchanForShowHistory">
        <v-card-title
          >نمایش جزئیات
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="openDetailDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text
          ><div
            v-for="(state, index) in selectedMerchanForShowHistory.states"
            :key="index"
          >
            <div v-html="state" class="my-2"></div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openCommentsDialog" max-width="800">
      <v-card v-if="selectedMerchanForShowComments">
        <v-card-title
          >نظرات ادمین سایت
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="openCommentsDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text
          ><div
            v-for="(comment, index) in selectedMerchanForShowComments.comments"
            :key="index"
          >
            <div class="my-2">
              {{ comment }}
            </div>
            <hr />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
const businessInformationRepository = () =>
  RepoFactory.get('businessInformation');
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumRepository = () => RepoFactory.get('enums');

export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  props: {
    merchantId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      MerchantHistoryStatusList: [],
      eventItems: [],
      headers: [
        {
          value: 'createdTimeUtc',
          text: 'تاریخ',
          sortable: true,
        },
        {
          value: 'status',
          text: 'وضعیت',
          sortable: true,
        },
        {
          value: 'comments',
          text: 'نظرات ادمین سایت',
          sortable: true,
        },
        {
          value: 'actions',
          text: 'اقدام',
        },
      ],
      selectedMerchanForShowHistory: null,
      openDetailDialog: false,
      selectedMerchanForShowComments: null,
      openCommentsDialog: false,
    };
  },
  created() {
    this.EventTypes();
    if (this.merchantId) {
      this.getMerchantHistories();
    }
  },
  watch: {
    merchantId(after) {
      if (after) this.getMerchantHistories();
    },
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  methods: {
    showAdminComments(item) {
      this.selectedMerchanForShowComments = item;
      this.openCommentsDialog = true;
    },
    showMerchantHistory(item) {
      this.selectedMerchanForShowHistory = item;
      this.openDetailDialog = true;
    },
    deleteMerchantHistory(item) {
      this.$dialog.warning({
        text: `آیا از حذف اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              businessInformationRepository()
                .deleteMerchantHistory(item.id, this.merchantBaseUrl, {
                  MerchantId: this.merchantId,
                })
                .then((data) => {
                  this.getMerchantHistories();
                  this.$dialog.message.success(' با موفقیت حذف گردید', {
                    position: 'top-left',
                  });
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                });
            },
          },
        },
      });
    },
    createComment(comments) {
      let commentString = '';
      comments.forEach((element, index) => {
        commentString =
          index < comments.length - 1
            ? commentString + element + ' - '
            : commentString + element;
      });
      return commentString && commentString.length > 30
        ? commentString.slice(0, 30) + '...'
        : commentString;
    },
    eventTypeDisplayName(title) {
      if (this.MerchantHistoryStatusList.length) {
        let result = this.MerchantHistoryStatusList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    EventTypes() {
      enumRepository()
        .getEnum('MerchantHistoryStatus', this.merchantBaseUrl)
        .then((res) => {
          this.MerchantHistoryStatusList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    getMerchantHistories() {
      const loader = this.$loading.show();
      businessInformationRepository()
        .getMerchantHistories(this.merchantBaseUrl, {
          MerchantId: this.merchantId,
        })
        .then((res) => {
          this.eventItems = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
